import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { SetMetaTags } from "../Components/Utility/setMetaTags";
import HomeV1 from "./HomeV1/HomeV1";

function Home() {
  const [loading, setLoading] = useState(true);
  const [homeExp, setHomeExp] = useState([]);
  const [exp2Data, setExp2Data] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState("$"); // Default symbol
  const [homeMeta, setHomeMeta] = useState();
  const navigate = useNavigate();


  const fetchHomeData = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/getCmsContent`,
        {
          post_url: "home",
        }
      );
      setHomeMeta(res.data.data);
    } catch (err) {
      console.error("Error fetching cancellation policy:", err);
    }
  };

  useEffect(() => {
  fetchAllData();
  fetchHomeData();

  // 🔹 Track current currency ID
  let currentCurrencyId = JSON.parse(localStorage.getItem("selectedCurrency"))?.id || 6;

  // 🔹 Refetch when currencyChange event is triggered manually
  const handleCurrencyChange = () => {
    
    fetchAllData();
  };
  window.addEventListener("currencyChange", handleCurrencyChange);

  // 🔹 Listen to changes in localStorage (other tabs)
  const handleStorageChange = (e) => {
    if (e.key === "selectedCurrency") {
      const updatedCurrency = JSON.parse(e.newValue);
      const newCurrencyId = updatedCurrency?.id || "";
      if (newCurrencyId !== currentCurrencyId) {
        
        currentCurrencyId = newCurrencyId;
        fetchAllData();
      }
    }
  };
  window.addEventListener("storage", handleStorageChange);

  // 🔹 Detect same-tab changes (when setItem is called manually)
  const localCheck = setInterval(() => {
    const local = JSON.parse(localStorage.getItem("selectedCurrency"))?.id || 6;
    if (local !== currentCurrencyId) {
      
      currentCurrencyId = local;
      fetchAllData();
    }
  }, 1200); // check every 1.2s

  // 🔹 Scroll to top on mount
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

  return () => {
    window.removeEventListener("currencyChange", handleCurrencyChange);
    window.removeEventListener("storage", handleStorageChange);
    clearInterval(localCheck);
  };
}, []);


  const fetchAllData = async () => {
    setLoading(true);
    await Promise.all([fetchHomeExperience(), fetchHomeExperience2()]);
    setLoading(false);
  };

  // ✅ Fetch Explorer's Top Choices
  const fetchHomeExperience = async () => {
    try {
      const selectedCurrency = JSON.parse(localStorage.getItem("selectedCurrency"));
      const currency_id = selectedCurrency?.id || 6; // ✅ fixed key
      const symbol = selectedCurrency?.symbol || "$";
      // setCurrencySymbol(symbol);

     

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/getHomeExperience?currency_id=${currency_id}`
      );

      if (res.data?.status) {
         if (res.data.currency?.currency_symbol) {
          setCurrencySymbol(res.data.currency.currency_symbol);
        }
        const mappedExp = res.data.data.map((item) => ({
          host_id: item.host_id,
          host_title: item.title,
          city_name: item.city_name,
           slug: item.url_slug,
          category_id: item.experience_id,
          country_name: item.country_name,
          price: item.price,
          rating: item.rating,
          img: res.data.base_url + item.image,
          alt_tag: item.alt_tag || item.title,
        }));
        setHomeExp(mappedExp);
      }
    } catch (err) {
      console.error("Error fetching Explorer's Top Choices:", err);
    }
  };

  // ✅ Fetch Weyfarin Crafted
  const fetchHomeExperience2 = async () => {
    try {
      const selectedCurrency = JSON.parse(localStorage.getItem("selectedCurrency"));
      const currency_id = selectedCurrency?.id || 6; // ✅ fixed key
      const symbol = selectedCurrency?.symbol || "$";
      // setCurrencySymbol(symbol);

      

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/getHomeExperience2?currency_id=${currency_id}`
      );

      if (res.data?.status && Array.isArray(res.data.option4)) {
        const mappedExp2 = res.data.option4.map((item) => ({
          host_id: item.host_id,
          host_title: item.title,
          city_name: item.city_name,
           slug: item.url_slug,
          country_name: item.country_name,
          category_id: item.experience_id,
          price: item.price,
          rating: item.rating,
          img: res.data.base_url + item.image,
          alt_tag: item.alt_tag || item.title,
        }));
        setExp2Data(mappedExp2);
         if (res.data.currency?.currency_symbol) {
          setCurrencySymbol(res.data.currency.currency_symbol);
        }
      }
    } catch (err) {
      console.error("Error fetching Weyfarin Crafted:", err);
    }
  };

  // Skeleton Loader
  const SkeletonCard = () => (
    <div className="skeleton">
      <div className="bike_mg_ar">
        <div className="skeleton-img"></div>
      </div>
      <div className="tx_box">
        <div className="skeleton-text short"></div>
        <div className="skeleton-text long"></div>
      </div>
    </div>
  );

  if (
    typeof window !== "undefined" &&
    (window.location.search.includes("-v1") ||
      window.location.search.includes("v1") ||
      window.location.hash.includes("-v1") ||
      window.location.pathname.endsWith("-v1"))
  ) {
    return <HomeV1 />;
  }

  return (
    <>
      {/* Explorer's Top Choices */}

      <section className="ser_v_araeea mng_bottomss manngess">

        <SetMetaTags
                title={homeMeta?.meta_title}
                description={homeMeta?.meta_description}
                keywords={homeMeta?.meta_keyword}
              />
        <div className="container hm_arrowss">
          <div className="al_sec_ctxt">
            <h2>Explorer's Top Choices</h2>
          </div>

          <div className="swiper-nav-btns">
            <div className="swiper-button-prev custom-prev"></div>
            <div className="swiper-button-next custom-next"></div>
          </div>

          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={20}
            slidesPerView={5}
            autoplay={{ delay: 2500 }}
            loop
            navigation={{
              prevEl: ".custom-prev",
              nextEl: ".custom-next",
            }}
            breakpoints={{
              0: { slidesPerView: 1.3 },
              768: { slidesPerView: 2.3 },
              1024: { slidesPerView: 5 },
            }}
          >
            {loading
              ? Array(5)
                  .fill(0)
                  .map((_, i) => (
                    <SwiperSlide key={i}>
                      <SkeletonCard />
                    </SwiperSlide>
                  ))
              : homeExp.length === 0
              ? (
                <div className="no-data">No Data Found</div>
              ) : (
                homeExp.map((exp, i) => (
                  <SwiperSlide key={i}>
                    <Link
                      className="bike_ara_all"
                      // to={`/experience/${exp.host_title
                      //   .replace(/[\s,]+/g, "-")
                      //   .toLowerCase()}-${exp.category_id}`}
                      to={`/experience/${exp.slug}`}
                    >
                      <div className="bike_mg_ar">
                        {exp.rating > 0 && (
                          <span className="reatingsg">
                            {exp.rating} <i className="fa fa-star"></i>
                          </span>
                        )}
                        <div className="mdll">
                          <img src={exp.img} className="mg_sm_araea" alt={exp.alt_tag} />
                        </div>
                      </div>
                      <div className="tx_box">
                        <h4>{exp.host_title}</h4>
                        {/* <p>
                          {exp.city_name ?? ""}
                          {exp.country_name ? `, ${exp.country_name}` : ""}
                        </p> */}
                        <p>
  {[exp.city_name, exp.country_name].filter(Boolean).join(", ")}
</p>

                        <span>
                          From {currencySymbol}{(Number(exp.price) || 0).toFixed(2)}/guest
                        </span>
                      </div>
                    </Link>
                  </SwiperSlide>
                ))
              )}
          </Swiper>
        </div>
      </section>

      {/* Weyfarin Crafted */}
      <section className="ser_v_araeea mng_bottomss manngess pt_top_0">
        <div className="container hm_arrowss">
          <div className="al_sec_ctxt">
            <h2>Weyfarin Crafted</h2>
          </div>

          <div className="swiper-nav-btns">
            <div className="swiper-button-prev custom-prev1"></div>
            <div className="swiper-button-next custom-next1"></div>
          </div>

          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={20}
            slidesPerView={5}
            autoplay={{ delay: 3000 }}
            loop
            navigation={{
              prevEl: ".custom-prev1",
              nextEl: ".custom-next1",
            }}
            breakpoints={{
              0: { slidesPerView: 1.3 },
              768: { slidesPerView: 2.3 },
              1024: { slidesPerView: 5 },
            }}
          >
            {loading
              ? Array(5)
                  .fill(0)
                  .map((_, i) => (
                    <SwiperSlide key={i}>
                      <SkeletonCard />
                    </SwiperSlide>
                  ))
              : exp2Data.length === 0
              ? (
                <div className="no-data">No Data Found</div>
              ) : (
                exp2Data.map((tour, i) => (
                  <SwiperSlide key={i}>
                    <Link
                      className="bike_ara_all"
                      // to={`/experience/${tour.host_title
                      //   .replace(/[\s,]+/g, "-")
                      //   .toLowerCase()}-${tour.category_id}`}
                      to={`/experience/${tour.slug}`}
                    >
                      <div className="bike_mg_ar">
                        {tour.rating > 0 && (
                          <span className="reatingsg">
                            {tour.rating} <i className="fa fa-star"></i>
                          </span>
                        )}
                        <div className="mdll">
                          <img src={tour.img} className="mg_sm_araea" alt={tour.alt_tag} />
                        </div>
                      </div>
                      <div className="tx_box">
                        <h4>{tour.host_title}</h4>
                        {/* <p>
                          {tour.city_name ?? ""}
                          {tour.country_name ? `, ${tour.country_name}` : ""}
                        </p> */}
                        <p>
  {[tour.city_name, tour.country_name].filter(Boolean).join(", ")}
</p>

                        <span>
                          From {currencySymbol}{Number(tour.price || 0).toFixed(2)}/guest
                        </span>
                      </div>
                    </Link>
                  </SwiperSlide>
                ))
              )}
          </Swiper>
        </div>
      </section>

      {/* Floating pill to easily switch to redesign */}
      <Link
        to="/-v1"
        style={{
          position: "fixed",
          bottom: "24px",
          right: "24px",
          background: "#0B1220",
          color: "#FFFFFF",
          padding: "10px 18px",
          borderRadius: "999px",
          fontSize: "13px",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: "8px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
          zIndex: 9999,
          textDecoration: "none",
        }}
      >
        <span
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            background: "#F5B31A",
          }}
        ></span>
        <span>Preview New Redesign (-v1)</span>
      </Link>
    </>
  );
}

export default Home;
